module.exports = __webpack_public_path__ + "img/Lake_Herrick_-_RN-t-25790-022.8b56d500.jpg";